export default "__VITE_ASSET__cdd40087__"